<div class="card user-device-card">
	<div class="card-body d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
		<div class="device-info">
			<h5 class="card-title mb-1">
				{{ device.deviceName || 'Unknown Device' }}
				<span *ngIf="isCurrentDevice" class="badge bg-primary ms-2">This Device</span>
			</h5>
			<p class="card-text mb-1"><strong>Platform:</strong> {{ device.platform | titlecase }}</p>
			<p class="card-text mb-1"><strong>Model:</strong> {{ device.deviceModel || 'N/A' }}</p>
			<p class="card-text text-muted small"><strong>Added:</strong> {{ device.createdAt.toDate().toISOString() | relativeTime }}</p>
		</div>

		<div class="mt-3 mt-md-0">
			<button type="button" class="btn btn-outline-danger btn-sm" (click)="onRemove()">Remove Device</button>
		</div>
	</div>
</div>
